const routes = {
  importInvoice: 'invoices/import',
  createInvoice: 'invoices',
  getInvoices: 'invoices',
  getInvoiceById: 'invoices/',
  updateInvoice: 'invoices/',
  deleteInvoice: 'invoices/',
  validateInvoice: 'invoices/validate',
  submitInvoice: 'invoices/submit',
  exportInvoices: 'invoices/export',
  bulkDelete: 'invoices/bulk-delete',
  bulkValidate: 'invoices/bulk-validate',
  bulkSubmit: 'invoices/bulk-submit',
};

export default routes